import { Components, Theme } from '@mui/material/styles';

export const muiAccordionDetailsOverride: Components<Theme>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(4, 0, 8, 0),
    }),
  },
};
